if (!customElements.get('product-sticky-bar')) {
  customElements.define(
    'product-sticky-bar',
    class ProductStickyBar extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.product-sticky-bar__button');
        this.targetButton = document.getElementById(this.dataset.targetButton);

        if (this.targetButton) {
          this.button.addEventListener('click', () => {
            this.targetButton.click();
          });

          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                // Only show once the visitor has scrolled past the original
                // button (it's above the viewport), not before reaching it.
                const scrolledPastButton = entry.boundingClientRect.top < 0;
                const shouldShow = !entry.isIntersecting && scrolledPastButton;
                this.classList.toggle('is-visible', shouldShow);
                document.body.classList.toggle('has-sticky-cart', shouldShow);
              });
            },
            { threshold: 0 }
          );
          this.observer.observe(this.targetButton);
        }
      }
    }
  );
}
